import React from "react"
import { useTranslation } from "react-i18next";
import { useStore } from "store";

function NavSelectionLabel({ data, setting }) {
    const { i18n } = useTranslation()
    const t = useStore(state => state.translations)
    const rotation = useStore(state => state.rotation)
    const control = useStore(state => state.control)

    function getIntlLabel() {
        const labelIntl = data[`label${i18n.language.toUpperCase()}`]
        return labelIntl ? labelIntl : data.label
    }

    if (data && data.label && setting === "rotation") {
        return <>{t.settings.rotation[`${rotation}Rotation`][i18n.language]}</>
    }

    if (data && data.label && setting === "size") {
        return data.label
    }

    if (data && data.label && ["theme", "table", "ring"].includes(setting)) {
        return getIntlLabel()
    }

    if (data && data.label && setting === "control") {
        return <>{t.settings.addons.remote[`${control === "manual" ? "manual" : "mobileApp"}`][i18n.language]}</>
    }

    return (<span style={{fontWeight: '300', opacity: '.5'}}>{t.navigation.pleaseSelect[i18n.language]}</span>)
}

export default NavSelectionLabel;